import { IonContent, IonPage, IonTitle } from '@ionic/react';
import { ReactElement } from 'react';
import { useParams } from 'react-router';
import { Machine, useGetMachineQuery } from '../../api/graphql/generated';
import { NestedPageHeader } from '../../components/header/page.header';
import { MachineDetails } from '../../components/machine/machine-details';
import { MachineProgramStatus } from '../../components/machine/machine-program-status';
import { useBeaconRouter } from '../../route/route.hooks';
import { MachineContextProvider } from './machine-context-provider';

interface RouteParams {
  id: string;
}

interface MachineDetailsPageProps {
  teamId: string;
}

const MachineDetailsPage = (props: MachineDetailsPageProps): ReactElement => {
  const { teamId } = props;

  const params = useParams<RouteParams>();
  const { id } = params;

  const { data } = useGetMachineQuery({
    variables: { input: { id, teamId } },
    fetchPolicy: 'cache-and-network',
  });

  const machine: Machine | undefined = data?.getMachine;

  const { builder } = useBeaconRouter();

  return (
    <IonPage id={getMachineDetailsPageId()}>
      <NestedPageHeader defaultBackRoute={builder.getMachineRoute(teamId, id)}>
        <IonTitle>
          {machine?.name}
          <div className="subtitle header-program-status">
            <MachineProgramStatus machine={machine} />
          </div>
        </IonTitle>
      </NestedPageHeader>
      <IonContent>
        <MachineContextProvider machineId={id} teamId={teamId}>
          <MachineDetails machine={machine} />
        </MachineContextProvider>
      </IonContent>
    </IonPage>
  );
};

const getMachineDetailsPageId = (): string => {
  return 'machine-details-page';
};

export { MachineDetailsPage, getMachineDetailsPageId };
